import React from 'react';
import { TextP } from '../Text';
import * as Styled from './styles';

type DateInputProps = {
  handleChange: (value: string, field: string) => void;
  label?: string | JSX.Element;
  keyName: string;
  inputValue: string;
  id: string;
  error?: string;
  isError?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
};

const InputDate = ({
  handleChange,
  label,
  keyName,
  inputValue,
  id,
  error,
  isError = false,
  disabled,
  style,
}: DateInputProps) => (
  <Styled.InputWrapper>
    {label && <Styled.LabelStyled htmlFor={id}>{label}</Styled.LabelStyled>}
    {error && (
      <Styled.ErrorWrapper>
        <TextP>{error}</TextP>
      </Styled.ErrorWrapper>
    )}
    <Styled.DateInputStyled
      style={style}
      type="date"
      id={id}
      value={inputValue === 'null' || inputValue === 'undefined' ? '' : inputValue}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
        handleChange(event.target.value, keyName);
      }}
      isError={isError}
      disabled={disabled}
    />
  </Styled.InputWrapper>
);

export default InputDate;
